module.exports = '<svg width="32" height="32" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M832 64v640q0 61-35.5 111T704 885v779q0 52-38 90t-90 38H448q-52 0-90-38t-38-90V885q-57-20-92.5-70T192 704V64q0-26 19-45t45-19 45 19 19 45v416q0 26 19 45t45 19 45-19 19-45V64q0-26 19-45t45-19 45 19 19 45v416q0 26 19 45t45 19 45-19 19-45V64q0-26 19-45t45-19 45 19 19 45zm768 0v1600q0 52-38 90t-90 38h-128q-52 0-90-38t-38-90v-512H992q-13 0-22.5-9.5T960 1120V320q0-132 94-226t226-94h256q26 0 45 19t19 45z" fill="#fff"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/cutlery-1.js
// module id = 1095
// module chunks = 14